import { useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { fetchBranches, setCurrentBranch } from '../../store/actions/branch';
import { IoChevronDownOutline } from 'react-icons/io5';

const SelectBranch = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const branches = useSelector(state => state.branch.data);
    const current = useSelector(state => state.branch.current);
    const hasTenant = useSelector(state => state.users.data?.tenant?.length > 0);
    const activeTenantBlocked = useSelector(state => state.users.data?.activeTenantBlocked);
    const tenantListLoaded = useSelector(state => state.users.data?.tenantListLoaded);

    const [open, setOpen] = useState(false);
    const [search, setSearch] = useState('');
    const ref = useRef(null);
    const searchRef = useRef(null);

    useEffect(() => {
        if (hasTenant && tenantListLoaded && !activeTenantBlocked) dispatch(fetchBranches());
    }, [dispatch, hasTenant, tenantListLoaded, activeTenantBlocked]);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const currentBranch = branches.find(b => b._id === current);

    const handleSelect = (id) => {
        dispatch(setCurrentBranch(id));
        setOpen(false);
        if (location.pathname === '/evidencelist') navigate('/evidencelist');
    };

    const filtered = search.length < 3
        ? branches
        : branches.filter(b => b.name.toLowerCase().includes(search.toLowerCase()));

    if (!hasTenant || branches.length === 0) return null;

    return (
        <div className="notification-center select-branch-wrapper" ref={ref}>
            <button className="select-branch-trigger" onClick={() => {
                if (!open) { setSearch(''); setTimeout(() => searchRef.current?.focus(), 50); }
                setOpen(o => !o);
            }}>
                <span>{currentBranch?.name ?? 'Vybrať prevádzku'}</span>
                <IoChevronDownOutline size={14} className={`select-branch-chevron${open ? ' open' : ''}`} />
            </button>

            {open && (
                <div className="notification-dropdown select-branch-dropdown">
                    <div className="notification-header">Prevádzky</div>
                    {branches.length > 5 && (
                        <div className="select-branch-search">
                            <input
                                ref={searchRef}
                                type="text"
                                placeholder="Hľadať prevádzku..."
                                value={search}
                                onChange={e => setSearch(e.target.value)}
                                className="select-branch-search-input"
                            />
                        </div>
                    )}
                    {filtered.length > 0 ? filtered.map(branch => (
                        <button
                            key={branch._id}
                            className={`user-menu-item select-branch-item${branch._id === current ? ' active' : ''}`}
                            onClick={() => handleSelect(branch._id)}
                        >
                            {branch.name}
                        </button>
                    )) : (
                        <div className="select-branch-no-results">Žiadna prevádzka nenájdená</div>
                    )}
                </div>
            )}
        </div>
    );
};

export default SelectBranch;
